import { FC, Fragment } from 'react';
//components
import AdminSidebar from './AdminSidebar';
import StaffSidebar from './StaffSidebar';
import SuperAdminSidebar from './SuperAdminSidebar';
// helper, hooks
import { useAuthContext } from 'contexts/AuthContext';
import { isSuperAdmin, isAdmin, isStaff } from 'lib/helper';

const Sidebar: FC = (): JSX.Element => {
  const { userRoles } = useAuthContext();
  const isSuper = isSuperAdmin(userRoles);
  const isOrgAdmin = isAdmin(userRoles);
  const isOrgStaff = isStaff(userRoles);

  return (
    <Fragment>
      {isSuper && <SuperAdminSidebar />}
      {isOrgAdmin && <AdminSidebar />}
      {isOrgStaff && <StaffSidebar />}
    </Fragment>
  );
};

export default Sidebar;
